import { useEffect } from 'react';
import { ILight } from '../lightTemplate';

type IPointLightProps = {
  instanceId: string;
  castShadow?: boolean;
  light?: ILight | undefined;
};

export const PointLight = (props: IPointLightProps) => {
  const lightRef = props.light?.ref;

  useEffect(() => {
    lightRef.current.castShadow = props.castShadow;

    lightRef.current.shadow.mapSize.width = props.light?.shadowMapWidth || 512;
    lightRef.current.shadow.mapSize.height =
      props.light?.shadowMapHeight || 512;

    lightRef.current.shadow.camera.near = props.light?.shadowCameraNear || 1;
    lightRef.current.shadow.camera.far = props.light?.shadowCameraFar || 500;

    lightRef.current.shadow.bias = props.light?.shadowBias || -0.002;

    lightRef.current.shadow.needsUpdate = true;
  }, []);

  return (
    <>
      <pointLight
        ref={lightRef}
        color={props.light?.color !== undefined ? props.light.color : 0xffffff}
        intensity={
          props.light?.intensity !== undefined ? props.light.intensity : 1.5
        }
        position={[0, 0, 0]}
        decay={props.light?.decay !== undefined ? props.light.decay : 0.0}
        distance={
          props.light?.distance !== undefined ? props.light.distance : 50
        }
        castShadow={props.castShadow !== undefined ? props.castShadow : false}
        name={`pointLight-${props.instanceId}`}
        key={`light-${props.instanceId}`}
      />
    </>
  );
};
